import { render, staticRenderFns } from "./TechnicalInformationComponent.vue?vue&type=template&id=bc81ffdc"
import script from "./TechnicalInformationComponent.vue?vue&type=script&lang=ts"
export * from "./TechnicalInformationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports